import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import * as Yup from 'yup';
import { Grid, IconButton, Rating } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import { GROUP_USER } from '../../../../../config/appGroupConfig';
import { deleteUserRating } from '../../../../../core/users/action';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

const styleReview = {
  my: 4,
};

const styleCenterAlign = {
  display: 'flex',
  alignItems: 'center',
};

function ModalReview({ open, handleClose, reviewee }) {
  const dispatch = useDispatch();
  const CustomizedSwal = withReactContent(Swal);

  const StyledDialog = makeStyles({
    root: {
      zIndex: '7 !important',
    },
  });
  const classes = StyledDialog();
  const [name, setName] = useState();
  const [address, setAddress] = useState();
  const [initialValues, setInitialValues] = useState({
    id: null,
    name: '',
    state: true,
  });

  useEffect(() => {
    console.log('UE ');
    if (reviewee) setInitialValues(reviewee);
    setName(
      reviewee.role.name === GROUP_USER.VENUE
        ? reviewee.venue.name
        : `${reviewee.name} ${reviewee.last_name} 
            ${reviewee.vendor_company_name ? `(${reviewee.vendor_company_name})` : ``}`,
    );
    setAddress(reviewee.role.name === GROUP_USER.VENUE ? reviewee.venue.business_address : '');
  }, [reviewee]);

  const deleteRating = (req) => {
    dispatch(deleteUserRating(req));
    handleClose(true);
  };

  const getConfirmationModal = (req, comment) => {
    CustomizedSwal.fire({
      title: `Do you want to remove this review?`,
      html: <i>{`"${comment}"`}</i>,
      confirmButtonText: 'Confirm',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRating(req);
      }
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.root}>
      <Box sx={style}>
        <Typography variant="h5">{name}</Typography>
        <Typography variant="body">{address}</Typography>
        <Typography variant="body2" sx={styleCenterAlign}>
          <Rating name="read-only" value={reviewee.averageScore} readOnly size="large" />
          <Box sx={{ ml: 2 }}> {`${reviewee.ratingsReceived.length} reviews`}</Box>
        </Typography>
        {reviewee.ratingsReceived.map((rating) => (
          <Grid key={rating.id} container sx={styleReview}>
            <Grid item xs={11} sx={styleCenterAlign}>
              <Rating name="read-only" value={rating.score} readOnly size="small" />
              <Typography variant="caption" sx={{ ml: 2, color: 'gray' }}>
                {moment(rating.created_at).format('LL')}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="delete"
                size="small"
                onClick={() =>
                  getConfirmationModal({ ratingId: rating.id, userId: reviewee.id }, rating.comment)
                }>
                <DeleteIcon fontSize="inherit" />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              {rating.comment}
              {rating.replies && rating.replies.length > 0 && (
                <Grid
                  item
                  xs={7}
                  sx={{ ml: 3, borderLeft: 4, pl: 1, borderLeftColor: 'lightgray' }}>
                  <Typography variant="body2" sx={{ color: 'gray' }}>
                    {rating.replies[0].comment}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        ))}
      </Box>
    </Modal>
  );
}

ModalReview.defaultProps = {
  reviewee: undefined,
};

ModalReview.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  reviewee: PropTypes.object,
};

export default ModalReview;
